module.exports = __webpack_public_path__ + "static/media/FullScreen.e7ae12e8.svg";